<template>
  <div class="score-container">
    <!-- 頁面標題區域 -->
    <div class="page-header">
      <div class="header-content">
        <h2 class="page-title">
          <a-icon type="trophy" />
          學分移轉
        </h2>
      </div>
    </div>

    <div v-if="defaultval.type=='county'" class="main-content">

    <!-- 流程步驟條 -->
      <div class="steps-section">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom:8px;">
            <div style="font-size: 16px; font-weight: 600; color: #1890ff;margin:1rem 1rem 0.5rem 1rem;">
                學分移轉
            </div>
            <div>
                <a-button type="link" @click="stepsCollapsed = !stepsCollapsed">
                <a-icon :type="stepsCollapsed ? 'down' : 'up'" />
                {{ stepsCollapsed ? '展開步驟' : '收起步驟' }}
                </a-button>
            </div>
        </div>
        <div v-show="!stepsCollapsed">       
        <div class="steps-card">
          <a-steps :current="active" class="custom-steps" style="margin-left: -3rem;margin-bottom: 1rem;">
            <a-step v-for="(step, index) in steps" :key="index" :title="step.title" :description="step.description">
              <a-icon slot="icon" :type="step.icon" />
            </a-step>
          </a-steps>

          <!-- 步驟內容區域 -->
          <div class="step-content">
        <!-- 步驟 0: 移轉者查詢 -->
        <div v-if="active === 0" class="step-panel">
        <div class="step-title">
            <a-icon type="search" />
            <h4>步驟一：查詢移轉者</h4>
        </div>
        <div class="step-body">
            <a-form layout="vertical">
            <a-row :gutter="16">
                <a-col :span="12">
                <a-form-item label="移轉者帳號">
                    <a-input-search
                    v-model="stepForm.transferorName"
                    placeholder="請輸入移轉者帳號"
                    enter-button="查詢"
                    size="large"
                    @search="searchTransferor"
                    :loading="searchLoading.transferor"
                    >
                    <a-icon slot="prefix" type="user" />
                    </a-input-search>
                </a-form-item>
                </a-col>
                <a-col :span="12">
                <!-- 移轉者學分 -->
                <a-form-item label="移轉者學分">
                    <div class="score-card">
                    <a-icon type="trophy" class="score-icon gold" />
                    <div class="score-info">
                        <span class="score-number">
                        {{ stepForm.transferorScore > 0 ? stepForm.transferorScore.toLocaleString() : '--' }}
                        </span>
                        <span class="score-text">點</span>
                    </div>
                    </div>
                </a-form-item>
                </a-col>
            </a-row>
            </a-form>
            <!-- 步驟 0: 移轉者查詢 - 搜索結果顯示 -->
            <div v-if="stepForm.transferorId" class="search-result">
            <a-alert type="success" show-icon>
                <template slot="message">
                <div class="user-found-info">
                    <a-avatar 
                    :src="searchResults.transferorList[0]?.avatar" 
                    :style="{ backgroundColor: '#1890ff' }"
                    size="small"
                    >
                    {{ (searchResults.transferorList[0]?.name || stepForm.transferorName).charAt(0) }}
                    </a-avatar>
                    <span>
                    找到用戶：{{ searchResults.transferorList[0]?.name || stepForm.transferorName }} 
                    (帳號: {{ stepForm.transferorName }}, ID: {{ stepForm.transferorId }})，
                    當前學分：{{ stepForm.transferorScore.toLocaleString() }}
                    </span>
                </div>
                </template>
            </a-alert>
            </div>
        </div>
        </div>

        <!-- 步驟 1: 接收人查詢 -->
        <div v-if="active === 1" class="step-panel">
        <div class="step-title">
            <a-icon type="user" />
            <h4>步驟二：查詢接收人</h4>
        </div>
        <div class="step-body">
            <a-form layout="vertical">
            <a-row :gutter="16">
                <a-col :span="12">
                <a-form-item label="接收人帳號">
                    <a-input-search
                    v-model="stepForm.receiverName"
                    placeholder="請輸入接收人帳號"
                    enter-button="查詢"
                    size="large"
                    @search="searchReceiver"
                    :loading="searchLoading.receiver"
                    >
                    <a-icon slot="prefix" type="user-add" />
                    </a-input-search>
                </a-form-item>
                </a-col>
                <a-col :span="12">
                <!-- 接收人學分 -->
                <a-form-item label="接收人學分">
                    <div class="score-card">
                    <a-icon type="trophy" class="score-icon green" />
                    <div class="score-info">
                        <span class="score-number">
                        {{ stepForm.receiverScore > 0 ? stepForm.receiverScore.toLocaleString() : '--' }}
                        </span>
                        <span class="score-text">點</span>
                    </div>
                    </div>
                </a-form-item>
                </a-col>
            </a-row>
            </a-form>
            <!-- 步驟 1: 接收人查詢 - 搜索結果顯示 -->
            <div v-if="stepForm.receiverId" class="search-result">
            <a-alert type="success" show-icon>
                <template slot="message">
                <div class="user-found-info">
                    <a-avatar 
                    :src="searchResults.receiverList[0]?.avatar" 
                    :style="{ backgroundColor: '#52c41a' }"
                    size="small"
                    >
                    {{ (searchResults.receiverList[0]?.name || stepForm.receiverName).charAt(0) }}
                    </a-avatar>
                    <span>
                    找到用戶：{{ searchResults.receiverList[0]?.name || stepForm.receiverName }} 
                    (帳號: {{ stepForm.receiverName }}, ID: {{ stepForm.receiverId }})，
                    當前學分：{{ stepForm.receiverScore.toLocaleString() }}
                    </span>
                </div>
                </template>
            </a-alert>
            </div>
        </div>
        </div>

        <!-- 步驟 2: 輸入移轉點數 -->
        <div v-if="active === 2" class="step-panel">
        <div class="step-title">
            <a-icon type="calculator" />
            <h4>步驟三：設定移轉點數</h4>
        </div>
        <div class="step-body">
            <!-- 移轉者可用點數顯示 -->
            <div class="available-score-info">
            <a-card size="small" class="score-info-card">
            <div class="score-info-content">
                <div class="transferor-info">
                <a-avatar 
                    size="small" 
                    :src="searchResults.transferorList[0]?.avatar || null" 
                    :style="{ backgroundColor: searchResults.transferorList[0]?.avatar ? 'transparent' : '#1890ff' }"
                >
                    <template v-if="!searchResults.transferorList[0]?.avatar">
                    {{ (searchResults.transferorList[0]?.name || stepForm.transferorName).charAt(0) }}
                    </template>
                </a-avatar>
                <div class="transferor-details-inline">
                    <span class="transferor-name-inline">
                    {{ searchResults.transferorList[0]?.name || stepForm.transferorName }}
                    </span>
                    <span class="transferor-account-inline">
                    ({{ searchResults.transferorList[0]?.account || stepForm.transferorName }})
                    </span>
                </div>
                </div>
                <div class="available-score">
                <span class="score-label">可用點數：</span>
                <span class="score-amount">{{ stepForm.transferorScore.toLocaleString() }}</span>
                <span class="score-unit">點</span>
                </div>
            </div>
            </a-card>
            </div>

            <a-form layout="vertical">
            <a-row :gutter="16" justify="center">
                <a-col :span="12">
                <a-form-item label="移轉點數">
                    <a-input-number 
                    v-model="stepForm.transferAmount" 
                    :min="1" 
                    :max="stepForm.transferorScore"
                    style="width: 100%;" 
                    placeholder="請輸入移轉點數"
                    :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    @change="validateTransferAmount"
                    >
                    <template slot="addonAfter">點</template>
                    </a-input-number>
                    
                    <!-- 輸入驗證提示 -->
                    <div v-if="transferAmountError" class="transfer-error">
                    <a-alert :message="transferAmountError" type="error" show-icon />
                    </div>
                    
                    <!-- 輸入提示 -->
                    <div v-if="stepForm.transferAmount > 0 && !transferAmountError" class="transfer-hint">
                    <a-alert 
                        :message="`將移轉 ${stepForm.transferAmount.toLocaleString()} 點，移轉者剩餘 ${(stepForm.transferorScore - stepForm.transferAmount).toLocaleString()} 點`" 
                        type="info" 
                        show-icon 
                    />
                    </div>
                </a-form-item>
                </a-col>
            </a-row>
            </a-form>

            <!-- 移轉預覽 -->
            <div v-if="stepForm.transferAmount > 0 && !transferAmountError" class="transfer-preview">
            <a-card size="small" title="移轉預覽" class="preview-card">
                <div class="preview-content">
                <div class="transfer-item">
                    <div class="transfer-label">
                    <a-icon type="arrow-down" style="color: #ff4d4f;" />
                    <span>移轉者</span>
                    </div>
                    <div class="transfer-detail">
                    <span class="user-name">{{ stepForm.transferorName }}</span>
                    <span class="score-change">
                        {{ stepForm.transferorScore.toLocaleString() }} → 
                        <strong style="color: #ff4d4f;">{{ (stepForm.transferorScore - stepForm.transferAmount).toLocaleString() }}</strong>
                    </span>
                    </div>
                </div>
                
                <div class="transfer-arrow">
                    <a-icon type="arrow-right" style="font-size: 20px; color: #1890ff;" />
                    <div class="transfer-amount">
                    <a-tag color="orange" style="font-size: 14px; padding: 4px 12px;">
                        {{ stepForm.transferAmount.toLocaleString() }} 點
                    </a-tag>
                    </div>
                </div>
                
                <div class="transfer-item">
                    <div class="transfer-label">
                    <a-icon type="arrow-up" style="color: #52c41a;" />
                    <span>接收者</span>
                    </div>
                    <div class="transfer-detail">
                    <span class="user-name">{{ stepForm.receiverName }}</span>
                    <span class="score-change">
                        {{ stepForm.receiverScore.toLocaleString() }} → 
                        <strong style="color: #52c41a;">{{ (parseInt(stepForm.receiverScore) + stepForm.transferAmount).toLocaleString() }}</strong>
                    </span>
                    </div>
                </div>
                </div>
            </a-card>
            </div>
        </div>
        </div>            

            <!-- 步驟 3: 確認移轉 -->
            <div v-if="active === 3" class="step-panel">
              <div class="step-title">
                <a-icon type="check-circle" />
                <h4>步驟四：確認移轉</h4>
              </div>
              <div class="step-body">
                <a-result
                  status="info"
                  title="請確認移轉信息"
                  sub-title="確認後將執行學分移轉，此操作不可撤銷"
                >
                  <template #extra>
                    <div class="transfer-summary">
                      <a-descriptions title="移轉詳情" bordered :column="1">
                        <a-descriptions-item label="移轉者">
                          <a-avatar size="small" :style="{ backgroundColor: '#1890ff' }">
                            {{ stepForm.transferorName.charAt(0) }}
                          </a-avatar>
                          {{ stepForm.transferorName }}
                        </a-descriptions-item>
                        <a-descriptions-item label="接收者">
                          <a-avatar size="small" :style="{ backgroundColor: '#52c41a' }">
                            {{ stepForm.receiverName.charAt(0) }}
                          </a-avatar>
                          {{ stepForm.receiverName }}
                        </a-descriptions-item>
                        <a-descriptions-item label="移轉點數">
                          <a-tag color="red" style="font-size: 16px; padding: 4px 12px;">
                            {{ stepForm.transferAmount }} 點
                          </a-tag>
                        </a-descriptions-item>
                      </a-descriptions>
                    </div>
                  </template>
                </a-result>
              </div>
            </div>
          </div>

          <!-- 步驟操作按鈕 -->
          <div class="step-actions">
            <a-button 
              v-if="active > 0" 
              @click="prevStep"
              size="large"
              class="step-btn"
            >
              <a-icon type="left" />
              上一步
            </a-button>
            
            <a-button 
              v-if="steps && active < steps.length - 1" 
              @click="nextStep"
              type="primary"
              size="large"
              class="step-btn"
              :disabled="!canProceedToNext"
            >
              下一步
              <a-icon type="right" />
            </a-button>
            
            <a-button 
              v-if="steps && active === steps.length - 1" 
              @click="executeTransfer"
              type="primary"
              size="large"
              class="step-btn execute-btn"
              :loading="transferring"
            >
              <a-icon type="check" />
              執行移轉
            </a-button>

            <a-button 
              @click="resetSteps"
              size="large"
              class="step-btn"
              style="margin-left: 16px;"
            >
              <a-icon type="reload" />
              重置
            </a-button>
          </div>
          </div>
        </div>
      </div>

      <!-- 數據展示區域 -->
      <div class="table-section">
        <div class="table-card">
          <div class="table-header">
            <h4><a-icon type="table" /> 移轉學分記錄</h4>
            <div class="table-stats">
              <span class="stat-item">
                <a-badge :count="myData ? myData.length : 0" show-zero>
                  <span>總記錄數</span>
                </a-badge>
              </span>
            </div>
          </div>

            <!-- 新增搜尋區域 -->
            <div class="search-section" style="margin-bottom: 16px;">
            <a-row :gutter="16">
                <a-col :span="8">
                <a-input-search
                    v-model="searchKeyword"
                    placeholder="請輸入帳號或姓名進行搜尋"
                    enter-button="搜尋"
                    size="default"
                    @search="handleSearch"
                    @change="handleSearchChange"
                    allowClear
                >
                    <a-icon slot="prefix" type="search" />
                </a-input-search>
                </a-col>
                <a-col :span="2">
                <a-button @click="clearSearch" icon="reload">
                    清除搜尋
                </a-button>
                </a-col>
                <a-col :span="10">
                <div class="search-result-info" v-if="searchKeyword">
                    <a-tag color="blue">
                        搜尋關鍵字：{{ searchKeyword }} | 找到 {{ pagination.total || 0 }} 筆記錄
                    </a-tag>
                </div>
                </a-col>
            </a-row>
            </div>          

          <a-table 
            v-if="Array.isArray(myData) && myData.length > 0"
            :columns="enhancedColumns"
            :row-key="record => record.id"
            :data-source="myData"
            :pagination="enhancedPagination"
            :loading="loading"
            @change="handleTableChange"
            :scroll="{ x: 800 }"
            class="modern-table"
            >    
            <!-- 現有的模板保持不變 -->
            <template slot="amount" slot-scope="text, record">
                <div class="amount-cell">
                <a-tag 
                    :color="record.amount > 0 ? 'green' : record.amount < 0 ? 'red' : 'default'"
                    class="amount-tag"
                >
                    <a-icon :type="record.amount > 0 ? 'arrow-up' : record.amount < 0 ? 'arrow-down' : 'minus'" />
                    {{ record.amount }}
                </a-tag>
                </div>
            </template>

            <template slot="type" slot-scope="text, record">
                <a-tag :color="record.type === 'earning' ? 'blue' : 'orange'">
                {{ coverNameType(record.type) }}
                </a-tag>
            </template>

            <template slot="action" slot-scope="text, record">
                <a-tag color="purple">
                {{ coverNameAction(record.action) }}
                </a-tag>
            </template>

            <template slot="detail" slot-scope="text">
                <div class="detail-cell">
                <a-tooltip :title="text">
                    <span>{{ text && text.length > 20 ? text.substring(0, 20) + '...' : text }}</span>
                </a-tooltip>
                </div>
            </template>

            <template slot="created_at" slot-scope="text">
                <div class="date-cell">
                <a-icon type="clock-circle" />
                {{ fdateformat(text) }}
                </div>
            </template>

            <template slot="tdisplayname" slot-scope="text">
                <div class="user-cell">
                <a-avatar size="small" :style="{ backgroundColor: '#1890ff' }">
                    {{ text ? text.charAt(0) : 'U' }}
                </a-avatar>
                <span class="user-name">{{ text }}</span>
                </div>
            </template>

            <template slot="udisplayname" slot-scope="text">
                <div class="user-cell">
                <a-avatar size="small" :style="{ backgroundColor: '#52c41a' }">
                    {{ text ? text.charAt(0) : 'U' }}
                </a-avatar>
                <span class="user-name">{{ text }}</span>
                </div>
            </template>

            <!-- 新增的輸出報表模板 -->
            <template slot="export" slot-scope="text, record">
                <div class="export-actions">
                <a-dropdown>
                    <a-button type="primary" size="small" icon="download">
                    報表
                    <a-icon type="down" />
                    </a-button>
                    <a-menu slot="overlay" @click="handleExportClick($event, record)">
                    <a-menu-item key="pdf">
                        <a-icon type="file-pdf" />
                        匯出 PDF
                    </a-menu-item>          
                    </a-menu>
                </a-dropdown>
                </div>
            </template>
            </a-table>

          <!-- 空狀態 -->
        <div v-else class="empty-state">
        <a-empty :description="searchKeyword ? '無符合條件的搜尋結果' : '暫無數據'">
            <a-button v-if="searchKeyword" @click="clearSearch">
            <a-icon type="reload" />
            清除搜尋
            </a-button>
            <a-button v-else type="primary" @click="reload">
            <a-icon type="reload" />
            重新加載
            </a-button>
        </a-empty>
        </div>
        </div>
      </div>
    </div>

    <!-- 無權限狀態 -->
    <div v-else class="no-permission">
      <a-result
        status="403"
        title="403"
        sub-title="抱歉，您沒有該項目的管理權限"
      >
        <template #extra>
          <a-button type="primary" @click="$router.go(-1)">
            返回上頁
          </a-button>
        </template>
      </a-result>
    </div>

  </div>
</template>
<script>
import * as moment from "moment/moment";
import { joinService } from '../../../_services'
import { mapState } from "vuex"; 
import html2pdf from "html2pdf.js";

const postCorporalScore = obj => {
    return joinService.postPersonalWithOid(obj) 
}
const queryData = params => {
  return joinService.findShiftScore(params) 
}; 

const findPersonalData = params => {
  return joinService.findPersonalData(params) 
};




export default {
  name: 'Shift_control', 
  components: {
  },     
  data() {
    return {
      data: [],
      myData:[],
      historyData:[],
      pagination: {defaultPageSize:4,pageSize: 4 }, 
      loading: false, 
      loading2: false, 
      stepsCollapsed: true,
      searchKeyword: '', // 搜尋關鍵字
      actives:{page1:false,page2:true,page3:false},
      active: 0,
      steps: [
        { 
          title: '移轉者查詢', 
          icon: 'search',
          description: '查詢要移轉學分的用戶'
        },
        { 
          title: '接收人查詢', 
          icon: 'user',
          description: '查詢接收學分的用戶'
        },
        { 
          title: '輸入移轉點數', 
          icon: 'calculator',
          description: '設定要移轉的點數'
        },
        { 
          title: '確認移轉', 
          icon: 'check-circle',
          description: '確認並執行移轉操作'
        }
      ],
      stepForm: {
        transferorName: '',     // 移轉者姓名（顯示用）
        transferorId: null,     // 移轉者ID (tid)
        transferorScore: 0,     // 移轉者當前學分（顯示用）
        receiverName: '',       // 接收者姓名（顯示用）
        receiverId: null,       // 接收者ID (uid)
        receiverScore: 0,       // 接收者當前學分（顯示用）
        transferAmount: 0,      // 移轉金額 (amount)
        transferReason: ''      // 移轉說明 (detail)
      },
      transferring: false,
      transferAmountError: '', // 移轉點數驗證錯誤信息  
      searchResults: {
                transferorList: [],
                receiverList: []
            },
    searchLoading: {
      transferor: false,
      receiver: false
    },
    searchAttempted: {
      transferor: false,
      receiver: false
    },                  
      activeTab: "score", // 預設顯示給分作業
      spinning: false,
      showModal: false, // 控制 a-modal 顯示
    };
  },
  computed: {
    ...mapState("account", ["status", "user"]),
    ...mapState("makeorg", ["defaultval"]),
    // ... 保留原有的 computed
    enhancedColumns() {
        return [
            {
            title: '執行人',
            dataIndex: 'tdisplayname',
            width: '15%',
            scopedSlots: { customRender: 'tdisplayname' },
            },
            {
            title: '接收人',
            dataIndex: 'udisplayname',
            width: '15%',
            scopedSlots: { customRender: 'udisplayname' },
            },
            {
            title: '學分',
            dataIndex: 'amount',
            width: '8%',
            scopedSlots: { customRender: 'amount' },
            sorter: true,
            },
            {
            title: '交易類型',
            dataIndex: 'type',
            width: '9%',
            scopedSlots: { customRender: 'type' },
            filters: [
                { text: '增加', value: 'earning' },
                { text: '扣除', value: 'spending' },
            ],
            },
            {
            title: '交易動作',
            dataIndex: 'action',
            width: '9%',
            scopedSlots: { customRender: 'action' },
            },
            {
            title: '交易說明',
            dataIndex: 'detail',
            width: '13%',          
            scopedSlots: { customRender: 'detail' },
            ellipsis: true,
            },
            {
            title: '建置時間',
            dataIndex: 'created_at',
            width: '13%',
            scopedSlots: { customRender: 'created_at' },
            sorter: true,
            },
            {
            title: '輸出報表',
            key: 'export',
            width: '10%',
            scopedSlots: { customRender: 'export' },
            align: 'center',
            },
        ];
        },
        // 👈 修改 displayData 直接使用 myData
        displayData() {
            return this.myData || [];
        },
        
        // 👈 修改 enhancedPagination 使用伺服器回傳的 total
        enhancedPagination() {
            return {
            ...this.pagination,
            // total 使用伺服器回傳的，在 fetch 方法中已設定
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) => `第 ${range[0]}-${range[1]} 條，共 ${total} 條記錄`,
            pageSizeOptions: ['4', '8', '12'],
            };
        },
    canProceedToNext() {
      switch (this.active) {
        case 0:
          return this.stepForm.transferorName && this.stepForm.transferorId && this.stepForm.transferorScore > 0;
        case 1:
          return this.stepForm.receiverName && this.stepForm.receiverId && this.stepForm.transferorId !== this.stepForm.receiverId;
        case 2:
          return this.stepForm.transferAmount > 0 && 
                 this.stepForm.transferAmount <= this.stepForm.transferorScore && 
                 !this.transferAmountError;
        default:
          return true;
      }
    },      
  },
  watch: {
    defaultval() {
      this.reload();
    }
  },  
  mounted() {
    this.reload();
  },
  methods: {

    fdateformat(val){
        return moment(val).format("YYYY-MM-DD HH:mm"); 
    },

    reload() {
        this.fetch({
            pageSize: this.pagination.pageSize || 4,
            page: 1,
            oid: parseInt(this.defaultval.id),
            searchKeyword: this.searchKeyword === '' ? 'all' : this.searchKeyword,
        });
    },

  // 處理報表輸出點擊事件
  handleExportClick({ key }, record) {
    console.log('輸出報表:', key, record);
    
    switch (key) {
      case 'pdf':
        this.exportToPDF(record);
        break;
      default:
        break;
    }
  }, 
   


    handleTableChange(pagination, filters, sorter) {
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
        
        if (!Array.isArray(this.myData)) {
            this.myData = [];
        }        
        
        this.fetch({
            pageSize: pagination.pageSize,
            page: pagination.current,
            sortField: sorter.field,
            sortOrder: sorter.order,
            oid: parseInt(this.defaultval.id),
            searchKeyword: this.searchKeyword === '' ? 'all' : this.searchKeyword, // 👈 加上判斷
            ...filters,
        });
    }, 
    fetch(params = {}) {
      this.loading = true;
      queryData({
          ...params,
      }).then(({ data }) => {
          const pagination = { ...this.pagination };
          pagination.total = data.info.totail;
          this.loading = false;
          this.myData = Array.isArray(data.results) ? data.results : [];
          this.pagination = pagination; 
      }).catch(error => {
          console.error('Fetch error:', error);
          this.loading = false;
          this.myData = [];
      });
    },

    // 修改 handleSearch 方法，搜尋時重新從伺服器取得資料
    handleSearch(value) {
        console.log('執行搜尋:', value);
        this.searchKeyword = value.trim();
        this.pagination.current = 1;
        
        this.fetch({
            pageSize: this.pagination.pageSize || 4,
            page: 1,
            oid: parseInt(this.defaultval.id),
            searchKeyword: this.searchKeyword === '' ? 'all' : this.searchKeyword, // 👈 加上判斷
        });
    },

  // 處理搜尋輸入變化
  handleSearchChange(e) {
    const value = e.target.value;
    if (!value) {
      this.clearSearch();
    }
  },    

    // 修改 clearSearch 方法
    clearSearch() {
        this.searchKeyword = '';
        this.pagination.current = 1;
        
        this.fetch({
            pageSize: this.pagination.pageSize || 4,
            page: 1,
            oid: parseInt(this.defaultval.id),
            searchKeyword: 'all', // 👈 直接使用 'all'
        });
    },    
   
    coverNameType(type) {
      if (type === 'earning') return '增加';
      if (type === 'spending') return '扣除';
      return '';
    },

    coverNameAction(action) {
      if (action === 1 || action === '1') return '購物紅利';
      if (action === 2 || action === '2') return '表現優異';
      if (action === 3 || action === '3') return '其它';  
      if (action === 4 || action === '4') return '移轉點數';
      if (action === 5 || action === '5') return '未綁定LINE帳號交易';
      return '';
    },
    
    onTypeChange(value) {
      if (this.form.amount === 0) return;
      if (value === 'spending' && this.form.amount > 0) {
        this.form.amount = -Math.abs(this.form.amount);
      } else if (value === 'earning' && this.form.amount < 0) {
        this.form.amount = Math.abs(this.form.amount);
      }
    },

// 步驟操作方法
    nextStep() {
      if (this.steps && this.active < this.steps.length - 1) {
        this.active++;
      }
    },
    
    prevStep() {
      if (this.active > 0) {
        this.active--;
      }
    },
    
    resetSteps() {
        this.active = 0;
        this.stepForm = {
        transferorName: '',
        transferorId: null,
        transferorScore: 0,
        receiverName: '',
        receiverId: null,
        receiverScore: 0,
        transferAmount: 0,
        transferReason: '' // 保留但不顯示在界面上
        };
        this.searchResults = {
        transferorList: [],
        receiverList: []
        };
        this.searchAttempted = {
        transferor: false,
        receiver: false
        };
        this.searchLoading = {
        transferor: false,
        receiver: false
        };
        this.transferAmountError = ''; // 重置錯誤信息
    },

    // 驗證移轉點數
    validateTransferAmount(value) {
        this.transferAmountError = '';
        
        if (!value || value <= 0) {
        this.transferAmountError = '請輸入有效的移轉點數';
        return false;
        }
        
        if (value > this.stepForm.transferorScore) {
        this.transferAmountError = `移轉點數不能超過可用點數 ${this.stepForm.transferorScore.toLocaleString()} 點`;
        return false;
        }
        
        return true;
    },    

    // 搜索移轉者
    async searchTransferor(value) {
    if (!value || !value.trim()) {
        this.$message.warning('請輸入移轉者帳號');
        return;
    }

    this.searchLoading.transferor = true;
    this.searchAttempted.transferor = true;
    
    // 清空之前的結果
    this.stepForm.transferorId = null;
    this.stepForm.transferorScore = 0;
    this.searchResults.transferorList = [];

    try {
        // 調用實際的 API 查詢
        const searchParams = {
        account: value.trim(),
        };
        
        console.log('搜索移轉者參數:', searchParams);
        
        const response = await findPersonalData(searchParams);
        
        console.log('搜索移轉者回應:', response);
        
        // 檢查 API 回應狀態 - 修正這裡
        if (response && response.data) {
        const apiResponse = response.data; // 取得實際的 API 回應
        
        // 檢查是否為 "user not found" 的情況
        if (apiResponse.code === 200 && apiResponse.msg === "user not found") {
            // 用戶不存在
            this.stepForm.transferorId = null;
            this.stepForm.transferorScore = 0;
            this.searchResults.transferorList = [];
            this.$message.warning('查無此帳號，請確認帳號是否正確');
            return;
        }
        
        // 檢查是否有用戶數據 - 修正這裡
        if (apiResponse.data && apiResponse.data.uid && apiResponse.data.uid > 0) {
            // 處理 API 回應數據
            const userData = apiResponse.data;
            
            this.stepForm.transferorId = userData.uid;
            this.stepForm.transferorScore = userData.totalscorereceiver || 0;
            this.stepForm.transferorName = userData.username; // 綁定帳號
            
            // 儲存完整的用戶資料到搜索結果中
            this.searchResults.transferorList = [{
            id: userData.uid,
            name: userData.display_name || userData.username, // 顯示名稱用於界面顯示
            account: userData.username, // 帳號
            score: userData.totalscorereceiver || 0,
            avatar: userData.avatar || '',
            username: userData.username
            }];
            
            this.$message.success(`查詢成功！找到用戶：${userData.display_name || userData.username} (${userData.username})`);
        } else {
            // 沒有找到用戶數據或其他錯誤情況
            this.stepForm.transferorId = null;
            this.stepForm.transferorScore = 0;
            this.searchResults.transferorList = [];
            
            // 根據 API 回應的 msg 來判斷錯誤類型
            if (apiResponse.msg) {
            this.$message.warning(`查詢失敗：${apiResponse.msg}`);
            } else {
            this.$message.warning('未找到該用戶，請確認帳號是否正確');
            }
        }
        } else {
        // API 回應格式不正確
        this.stepForm.transferorId = null;
        this.stepForm.transferorScore = 0;
        this.searchResults.transferorList = [];
        this.$message.warning('未找到該用戶，請確認帳號是否正確');
        }
        
    } catch (error) {
        console.error('搜索移轉者失敗:', error);
        
        // 處理不同類型的錯誤
        if (error.response) {
        // 伺服器回應錯誤
        const status = error.response.status;
        if (status === 404) {
            this.$message.warning('查無此帳號');
        } else if (status === 403) {
            this.$message.error('沒有查詢權限');
        } else if (status >= 500) {
            this.$message.error('伺服器錯誤，請稍後再試');
        } else {
            this.$message.error('查詢失敗，請稍後再試');
        }
        } else if (error.request) {
        // 網路錯誤
        this.$message.error('網路連線失敗，請檢查網路狀態');
        } else {
        // 其他錯誤
        this.$message.error('查詢失敗，請稍後再試');
        }
        
        // 清空結果
        this.stepForm.transferorId = null;
        this.stepForm.transferorScore = 0;
        this.searchResults.transferorList = [];
        
    } finally {
        this.searchLoading.transferor = false;
    }
    },

    // 搜索接收者 (同樣修正)
    async searchReceiver(value) {
    if (!value || !value.trim()) {
        this.$message.warning('請輸入接收人帳號');
        return;
    }

    this.searchLoading.receiver = true;
    this.searchAttempted.receiver = true;
    
    // 清空之前的結果
    this.stepForm.receiverId = null;
    this.stepForm.receiverScore = 0;
    this.searchResults.receiverList = [];

    try {
        // 調用實際的 API 查詢
        const searchParams = {
        account: value.trim(),
        };

        console.log('搜索接收者參數:', searchParams);
        
        const response = await findPersonalData(searchParams);
        
        console.log('搜索接收者回應:', response);

        // 檢查 API 回應狀態 - 修正這裡
        if (response && response.data) {
        const apiResponse = response.data; // 取得實際的 API 回應
        
        // 檢查是否為 "user not found" 的情況
        if (apiResponse.code === 200 && apiResponse.msg === "user not found") {
            // 用戶不存在
            this.stepForm.receiverId = null;
            this.stepForm.receiverScore = 0;
            this.searchResults.receiverList = [];
            this.$message.warning('查無此帳號，請確認帳號是否正確');
            return;
        }
        
        // 檢查是否有用戶數據 - 修正這裡
        if (apiResponse.data && apiResponse.data.uid && apiResponse.data.uid > 0) {
            // 處理 API 回應數據
            const userData = apiResponse.data;
            
            // 檢查是否與移轉者相同
            if (userData.uid === this.stepForm.transferorId) {
            this.$message.error('接收人不能與移轉者相同');
            return;
            }
            
            this.stepForm.receiverId = userData.uid;
            this.stepForm.receiverScore = userData.totalscorereceiver || 0;
            this.stepForm.receiverName = userData.username; // 綁定帳號
            
            // 儲存完整的用戶資料到搜索結果中
            this.searchResults.receiverList = [{
            id: userData.uid,
            name: userData.display_name || userData.username, // 顯示名稱用於界面顯示
            account: userData.username, // 帳號
            score: userData.totalscorereceiver || 0,
            avatar: userData.avatar || '',
            username: userData.username
            }];
            
            this.$message.success(`查詢成功！找到用戶：${userData.display_name || userData.username} (${userData.username})`);
        } else {
            // 沒有找到用戶數據或其他錯誤情況
            this.stepForm.receiverId = null;
            this.stepForm.receiverScore = 0;
            this.searchResults.receiverList = [];
            
            // 根據 API 回應的 msg 來判斷錯誤類型
            if (apiResponse.msg) {
            this.$message.warning(`查詢失敗：${apiResponse.msg}`);
            } else {
            this.$message.warning('未找到該用戶，請確認帳號是否正確');
            }
        }
        } else {
        // API 回應格式不正確
        this.stepForm.receiverId = null;
        this.stepForm.receiverScore = 0;
        this.searchResults.receiverList = [];
        this.$message.warning('未找到該用戶，請確認帳號是否正確');
        }
        
    } catch (error) {
        console.error('搜索接收者失敗:', error);
        
        // 處理不同類型的錯誤
        if (error.response) {
        // 伺服器回應錯誤
        const status = error.response.status;
        if (status === 404) {
            this.$message.warning('查無此帳號');
        } else if (status === 403) {
            this.$message.error('沒有查詢權限');
        } else if (status >= 500) {
            this.$message.error('伺服器錯誤，請稍後再試');
        } else {
            this.$message.error('查詢失敗，請稍後再試');
        }
        } else if (error.request) {
        // 網路錯誤
        this.$message.error('網路連線失敗，請檢查網路狀態');
        } else {
        // 其他錯誤
        this.$message.error('查詢失敗，請稍後再試');
        }
        
        // 清空結果
        this.stepForm.receiverId = null;
        this.stepForm.receiverScore = 0;
        this.searchResults.receiverList = [];
        
    } finally {
        this.searchLoading.receiver = false;
    }
    },
    // 執行移轉
    async executeTransfer() {
    this.$confirm({
        title: '確認執行學分移轉',
        content: `確定要將 ${this.stepForm.transferAmount.toLocaleString()} 點學分從 ${this.stepForm.transferorName} 移轉給 ${this.stepForm.receiverName} 嗎？`,
        okText: '確認移轉',
        cancelText: '取消',
        okType: 'danger',
        onOk: async () => {
        this.transferring = true;
        try {
            // 自動生成移轉說明
            const transferReason = `學分移轉 ${this.stepForm.transferAmount} 點`;
            
            // 構建移轉數據 - 一次完成移轉者扣除和接收者增加
            const transferData = {
            action: 4,                    // 移轉代號
            amount: this.stepForm.transferAmount,  // 移轉金額
            detail: `從 ${this.stepForm.transferorName} 移轉給 ${this.stepForm.receiverName}：${transferReason}`, // 備註說明
            tid: this.stepForm.transferorId,      // 移轉者id
            type: "transfer",             // 移轉類型（如果API支援）
            uid: this.stepForm.receiverId,        // 接收者id
            from_uid: this.stepForm.transferorId, // 移轉者id（如果API需要）
            to_uid: this.stepForm.receiverId,     // 接收者id（如果API需要）
            oid: parseInt(this.defaultval.id),     // 組織ID
            cid: this.user.data.user.id //創建者id
            };

            console.log('移轉數據:', transferData);

            try {
            const data = await postCorporalScore(transferData);
            
            if (data) {
                this.$message.success("學分移轉成功！");
                
                // 延遲重新載入數據和重置步驟
                setTimeout(() => {
                this.reload(); // 重新載入數據
                this.resetSteps(); // 重置步驟
                }, 1500);
                
            } else {
                this.$message.error("學分移轉失敗");
            }
            
            } catch (error) {
            console.error('移轉API調用失敗:', error);
            
            // 根據錯誤類型顯示不同的錯誤訊息
            if (error.response) {
                const status = error.response.status;
                if (status === 403) {
                this.$message.error('沒有操作權限，請聯繫管理員');
                } else if (status === 400) {
                this.$message.error('移轉參數錯誤，請檢查輸入資料');
                } else if (status >= 500) {
                this.$message.error('伺服器錯誤，請稍後再試');
                } else {
                this.$message.error('移轉失敗，請稍後再試');
                }
            } else if (error.message) {
                this.$message.error(error.message);
            } else {
                this.$message.error('移轉失敗，請稍後再試');
            }
            }
            
        } catch (error) {
            console.error('移轉過程失敗:', error);
            this.$message.error('移轉失敗，請稍後再試');
        } finally {
            this.transferring = false;
        }
        },
        onCancel: () => {
        console.log('用戶取消移轉操作');
        }
    });
    } ,
    
// 匯出 PDF
// 修正後的 exportToPDF 方法
async exportToPDF(record) {
  try {
    this.$message.loading('正在生成 PDF 報表...', 0);
    
    console.log('開始生成 PDF，record:', record);
  const overlay = document.createElement('div');
  overlay.id = 'pdf-loading-overlay';
  overlay.innerHTML = `
    <div style="
      position: fixed; left: 0; top: 0; width: 100vw; height: 100vh;
      background: rgba(0,0,0,0.45); z-index: 99999;
      display: flex; align-items: center; justify-content: center;
    ">
      <div style="
        background: #fff; border-radius: 12px; padding: 32px 48px;
        box-shadow: 0 8px 32px rgba(0,0,0,0.2); text-align: center;
      ">
        <div style="
          width: 48px; height: 48px; margin: 0 auto 16px auto;
          border: 4px solid #eee; border-top: 4px solid #1890ff;
          border-radius: 50%; animation: spin 1s linear infinite;
        "></div>
        <div style="font-size: 18px; font-weight: 600; color: #333;">正在生成 PDF 報表...</div>
        <div style="font-size: 14px; color: #888; margin-top: 8px;">請稍候，完成後自動關閉</div>
      </div>
    </div>
    <style>
      @keyframes spin { 0%{transform:rotate(0deg);} 100%{transform:rotate(360deg);} }
    </style>
  `;
  document.body.appendChild(overlay);    
    
    // 根據 orderkey 搜尋相關的兩筆記錄
    const relatedRecords = this.myData.filter(item => item.orderkey === record.orderkey);
    
    if (relatedRecords.length === 0) {
      this.$message.destroy();
      this.$message.warning('找不到相關的交易記錄');
      return;
    }
    
    // 生成 PDF 內容
    const reportContent = this.generatePDFContent(relatedRecords, record.orderkey);
    
    // 創建臨時容器 - 關鍵修正
    const element = document.createElement('div');
    element.innerHTML = reportContent;
    
    // 修正樣式設定 - 確保元素可見且有正確尺寸
    element.style.position = 'fixed';  // 改為 fixed
    element.style.left = '0';          // 改為 0，讓元素可見
    element.style.top = '0';
    element.style.width = '210mm';     // A4 寬度
    element.style.minHeight = '297mm'; // A4 高度
    element.style.padding = '10mm';
    element.style.backgroundColor = 'white';
    element.style.fontFamily = 'Arial, sans-serif';
    element.style.fontSize = '12px';
    element.style.lineHeight = '1.4';
    element.style.zIndex = '-9';     // 確保在最上層
    element.style.visibility = 'visible'; // 確保可見
    element.style.overflow = 'visible';
    element.style.boxSizing = 'border-box';
    
    // 插入到 DOM 中
    document.body.appendChild(element);
    
    console.log('DOM 元素已插入，檢查內容:');
    console.log('innerHTML 長度:', element.innerHTML.length);
    console.log('元素尺寸:', element.offsetWidth, 'x', element.offsetHeight);
    console.log('元素位置:', element.offsetLeft, ',', element.offsetTop);
    
    // 增加等待時間讓 DOM 完全渲染
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // 再次檢查
    console.log('等待後元素尺寸:', element.offsetWidth, 'x', element.offsetHeight);
    
    // 如果元素尺寸還是 0，強制設定
    if (element.offsetWidth === 0 || element.offsetHeight === 0) {
      console.warn('元素尺寸為 0，強制設定');
      element.style.width = '794px';   // A4 橫向像素寬度
      element.style.height = '1123px'; // A4 橫向像素高度
      element.style.display = 'block';
      
      await new Promise(resolve => setTimeout(resolve, 500));
    }
    
    // html2pdf 設定選項 - 修正設定
    const options = {
    margin: [1, 1, 1, 1], // 上、右、下、左邊距
    filename: `學分交易記錄報表_${record.orderkey}_${new Date().toISOString().slice(0, 10)}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    pagebreak: { mode: [] },
    html2canvas: {
        scale: 2,
        logging: true,
        useCORS: false,
        allowTaint: true,
        letterRendering: true,
        width: 794,
        height: 1123,
        backgroundColor: '#ffffff',
        windowWidth: 794,
        windowHeight: 1123,
        scrollX: 0,
        scrollY: 0,
        x: 0,
        y: 0
    }
    };
    
    console.log('html2pdf 選項:', options);
    console.log('開始 html2pdf 轉換...');
    
    try {
      // 使用 html2pdf 生成 PDF
      const pdf = html2pdf();
      
      await pdf.set(options)
               .from(element)
               .toPdf()
               .get('pdf')
               .then(function (pdfObj) {
                 console.log('PDF 對象創建成功');
                 console.log('PDF 頁數:', pdfObj.internal.getNumberOfPages());
                 console.log('PDF 尺寸:', pdfObj.internal.pageSize);
               })
               .save();
      
      this.$message.destroy();
      this.$message.success('PDF 報表已下載');
      
    } catch (pdfError) {
      console.error('html2pdf 轉換失敗:', pdfError);
      this.$message.destroy();
      this.$message.error('PDF 生成失敗，請稍後再試');
      
      // 如果 html2pdf 失敗，提供 fallback 方案
      this.fallbackPrintPDF(element, record.orderkey);
    }
    
    // 清理臨時元素
    setTimeout(() => {
      if (document.body.contains(element)) {
        document.body.removeChild(element);
      }
    }, 2000);
    
  } catch (error) {
    this.$message.destroy();
    this.$message.error('PDF 報表生成失敗');
    console.error('PDF 生成錯誤:', error);
  }finally {
    // 完成後自動移除遮罩
    setTimeout(() => {
      const el = document.getElementById('pdf-loading-overlay');
      if (el) document.body.removeChild(el);
    }, 1200); // 可依實際狀況調整延遲時間
  }
},

// 修正 fallbackPrintPDF 方法 - 移除未使用的 orderkey 參數
fallbackPrintPDF(element) {  // 移除 orderkey 參數
  console.log('使用 fallback 列印方法');
  
  // 創建新視窗來列印
  const printWindow = window.open('', '_blank', 'width=800,height=600');
  
  if (!printWindow) {
    this.$message.error('無法開啟列印視窗，請檢查瀏覽器設定');
    return;
  }
  
  const printHTML = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>學分交易記錄報表</title>
      <style>
        @page {
          size: A4;
          margin: 10mm;
        }
        
        @media print {
          body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
            margin: 0;
            padding: 0;
            background: white;
          }
          
          * {
            box-sizing: border-box;
          }
        }
        
        body {
          font-family: Arial, sans-serif;
          line-height: 1.4;
          color: #333;
          background: white;
          margin: 0;
          padding: 20px;
        }
        
        table {
          border-collapse: collapse !important;
        }
        
        th, td {
          border: 1px solid #ddd !important;
          padding: 8px !important;
        }
        
        th {
          background-color: #1890ff !important;
          color: white !important;
        }
        
        .amount-positive {
          color: #52c41a !important;
          font-weight: bold;
        }
        
        .amount-negative {
          color: #ff4d4f !important;
          font-weight: bold;
        }
      </style>
    </head>
    <body>
      ${element.innerHTML}
    </body>
    </html>
  `;
  
  printWindow.document.write(printHTML);
  printWindow.document.close();
  
  printWindow.onload = () => {
    setTimeout(() => {
      printWindow.print();
      this.$message.info('請在列印對話框中選擇「另存為PDF」');
      
      // 監聽列印完成
      printWindow.addEventListener('afterprint', () => {
        printWindow.close();
      });
    }, 500);
  };
},

// ...existing code... 

// 完善的 generatePDFContent 方法 - 包含浮水印和完整摘要 
generatePDFContent(records, orderkey) {
  console.log('generatePDFContent 開始執行');
  
  const currentDate = new Date().toLocaleString('zh-TW', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
  
  // 安全地獲取用戶信息
  let reporterInfo = '未知用戶';
  try {
    if (this.user?.data?.user) {
      reporterInfo = `${this.user.data.user.id} | ${this.user.data.user.username}`;
    }
  } catch (e) {
    console.warn('獲取用戶信息失敗:', e);
  }
  
  // 安全地獲取組織名稱
  let watermark = '系統';
  try {
    if (this.defaultval?.name) {
      watermark = this.defaultval.name;
    }
  } catch (e) {
    console.warn('獲取組織信息失敗:', e);
  }
  
  // 計算摘要數據
  const transferAmount = Math.abs(records[0]?.amount || 0);
  const transferor = records.find(r => r.amount < 0)?.tdisplayname || '-';
  const receiver = records.find(r => r.amount > 0)?.udisplayname || '-';
  const executeTime = records[0]?.created_at ? this.fdateformat(records[0].created_at) : '-';
  const creaters = records.find(r => r.amount > 0)?.cdisplayname || '-';
  const totalRecords = records.length;
  
  // 生成表格行
  const tableRows = records.map((record) => {
    const amountClass = record.amount > 0 ? 'amount-positive' : 'amount-negative';
    
    return `
      <tr style="border-bottom: 1px solid #e8e8e8;">
        <td style="padding: 10px 8px; border: 1px solid #e8e8e8; text-align: center; font-size: 12px;">${record.tdisplayname || '-'}</td>
        <td style="padding: 10px 8px; border: 1px solid #e8e8e8; text-align: center; font-size: 12px;">${record.udisplayname || '-'}</td>
        <td style="padding: 10px 8px; border: 1px solid #e8e8e8; text-align: center; font-weight: bold; font-size: 12px;" class="${amountClass}">${record.amount}</td>
        <td style="padding: 10px 8px; border: 1px solid #e8e8e8; text-align: center; font-size: 12px;">${this.coverNameType(record.type)}</td>
        <td style="padding: 10px 8px; border: 1px solid #e8e8e8; text-align: center; font-size: 12px;">${this.coverNameAction(record.action)}</td>
        <td style="padding: 10px 8px; border: 1px solid #e8e8e8; text-align: left; font-size: 11px; max-width: 300px; word-wrap: break-word;">${record.detail || '-'}</td>
        <td style="padding: 10px 8px; border: 1px solid #e8e8e8; text-align: center; font-size: 11px;">${this.fdateformat(record.created_at)}</td>
      </tr>
    `;
  }).join('');
  
  // 完整的 HTML 結構，包含浮水印和摘要
  const htmlContent = `
    <div style="font-family: 'Microsoft YaHei', Arial, sans-serif; background: #fff; color: #333; padding: 0; margin: 0; width: 100%; box-sizing: border-box; position: relative; page-break-inside: avoid;">
      <!-- 浮水印 -->
  <div style="
    position: absolute;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%) rotate(-45deg);
    font-size: 80px;
    font-weight: bold;
    color: rgba(0,0,0,0.06);
    z-index: 99999;
    pointer-events: none;
    user-select: none;
    white-space: nowrap;
  ">
    ${watermark}
  </div>
    <div style="position: relative; z-index: 1; padding: 32px 32px 16px 32px;">
      <!-- 標題 + 簽名用印方格 -->
      <div style="display: flex; align-items: center; justify-content: space-between; border-bottom: 3px solid #1890ff; padding-bottom: 12px; margin-bottom: 20px;">
        <div style="display: flex; align-items: center;">
          <h1 style="color: #1890ff; font-size: 28px; margin: 0;">🏆 學分交易記錄報表</h1>
          <div style="color: #888; font-size: 14px; margin-left: 12px;">Credit Transaction Report</div>
        </div>
        <!-- 新增簽名用印方格 -->
        <div style="
          border: 2px solid #d5d3d3;
          border-radius: 4px;
          width: 165px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          color: #d5d3d3;
          background: transparent;
          margin-left: 24px;
        ">
          簽名用印
        </div>
      </div>  
      <div style="position: relative; z-index: 1; padding: 32px 32px 16px 32px;">        
        <!-- 基本資訊 -->
        <table style="width: 100%; margin-bottom: 18px; border-collapse: collapse; font-size: 14px;">
        <tr>
            <td style="text-align:center;"><b>列印報表：</b>${reporterInfo}</td>
            <td style="text-align:center;"><b>列印日期：</b>${currentDate}</td>
            <td style="text-align:center;"><b>記錄筆數：</b>${totalRecords} 筆</td>
        </tr>
        </table>
        <!-- 摘要 -->
        <div style="display: flex; gap: 24px; margin-bottom: 18px;">
          <div style="flex:1; background: #f6f8fa; border-radius: 8px; border: 1px solid #e1e8ed; padding: 18px;">
            <div style="font-weight: bold; color: #1890ff; margin-bottom: 10px;">📈 交易摘要</div>
            <div><b>🆔 交易序號：</b>${orderkey}</div>
            <div><b>💰 交易金額：</b>${transferAmount} 點</div>
            <div><b>🔄 交易類型：</b>學分移轉</div>
            <div><b>✅ 交易狀態：</b>已完成</div>
            <div><b>📤 移轉者：</b>${transferor}</div>
            <div><b>📥 接收者：</b>${receiver}</div>
            <div><b>🛠️ 創建者：</b>${creaters}</div>
            <div><b>⏰ 執行時間：</b>${executeTime}</div>
          </div>
        </div>
        <!-- 詳細記錄 -->
        <div>
          <div style="font-weight: bold; color: #1890ff; margin-bottom: 8px;">📋 詳細記錄</div>
          <table style="width: 100%; border-collapse: collapse; background: #fff; border: 1px solid #e8e8e8; font-size: 13px;">
            <thead>
              <tr style="background: #1890ff; color: #fff;">
                <th>執行人</th>
                <th>接收人</th>
                <th>學分</th>
                <th>交易類型</th>
                <th>交易動作</th>
                <th>交易說明</th>
                <th>建置時間</th>
              </tr>
            </thead>
            <tbody>
              ${tableRows}
            </tbody>
          </table>
        </div>
        <!-- 頁腳 -->
        <div style="margin-top: 24px; text-align: center; color: #999; font-size: 12px; border-top: 1px solid #e8e8e8; padding-top: 12px;">
          🏢 此報表由系統自動生成 | 組織：<b>${watermark}</b> | 生成時間：<b>${currentDate}</b>
          <div style="margin-top: 6px; font-size: 11px; color: #ff4d4f;">⚠️ 本報表包含敏感資訊，請妥善保管並確保資料安全</div>
        </div>
      </div>
      <style>
        .amount-positive { color: #52c41a !important; font-weight: bold; }
        .amount-negative { color: #ff4d4f !important; font-weight: bold; }
        table, th, td { border: 1px solid #e8e8e8; }
        th, td { padding: 8px; text-align: center; }
        th { background: #1890ff !important; color: #fff !important; }
        tr:nth-child(even) { background: #f9f9f9; }
        tr:nth-child(odd) { background: #fff; }
        /* 防止分頁 */
        table, tr, td, th, div { page-break-inside: avoid !important; }
      </style>
    </div>
  `;
  
  console.log('HTML 內容生成完成，總長度:', htmlContent.length);
  
  return htmlContent;
}

// ...existing code...

  },
};
</script>
<style scoped>
.score-container {
  padding: 16px;
  background: #f0f2f5;
  min-height: 100vh;
}

.page-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 14px;
  color: white;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
}

.header-content h2 {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 600;
    color: rgb(245, 243, 243);
}

.header-content p {
  margin: 0;
  opacity: 0.9;
  font-size: 16px;
}

.main-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.action-section,
.steps-section,
.table-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.action-card,
.steps-card,
.table-card {
  padding: 24px;
}

.card-header {
  margin-bottom: 16px;
}

.card-header h3 {
  margin: 0;
  color: #1890ff;
  font-size: 18px;
  font-weight: 600;
}

.primary-btn {
  height: 48px;
  padding: 0 32px;
  font-size: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.table-stats {
  display: flex;
  gap: 16px;
}

.modern-table {
  border-radius: 8px;
  overflow: hidden;
}

.modern-table :deep(.ant-table-thead > tr > th) {
  background: #fafafa;
  font-weight: 600;
}

.amount-cell {
  display: flex;
  justify-content: center;
}

.amount-tag {
  font-weight: 600;
  border-radius: 20px;
  padding: 4px 12px;
}

.detail-cell {
  max-width: 200px;
}

.date-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
}

.user-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.user-name {
  font-weight: 500;
}

.empty-state {
  padding: 48px 0;
  text-align: center;
}

.no-permission {
  background: white;
  border-radius: 12px;
  padding: 48px;
  text-align: center;
}

.score-modal :deep(.ant-modal-header) {
  background: linear-gradient(135deg, #1890ff, #722ed1);
  color: white;
  border-radius: 8px 8px 0 0;
}

.score-modal :deep(.ant-modal-title) {
  color: white;
  font-weight: 600;
}

.modal-content {
  padding: 8px;
}

.form-section,
.member-section {
  background: #fafafa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
}

.form-title,
.member-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.form-title h4,
.member-title h4 {
  margin: 0;
  color: #1890ff;
  font-weight: 600;
}

.score-form :deep(.ant-form-item-label > label) {
  font-weight: 600;
}

.member-selector {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: white;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.action-buttons .ant-btn {
  min-width: 120px;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
}

/* 響應式設計 */
@media (max-width: 768px) {
  .score-container {
    padding: 16px;
  }
  
  .page-header {
    padding: 24px 16px;
  }
  
  .action-card,
  .steps-card,
  .table-card {
    padding: 16px;
  }
  
  .score-modal {
    margin: 16px;
  }
}

/* 動畫效果 */
.action-section,
.steps-section,
.table-section {
  transition: all 0.3s ease;
}

.action-section:hover,
.steps-section:hover,
.table-section:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}
.steps-header {
  margin-bottom: 24px;
}

.steps-header h3 {
  margin: 0;
  color: #1890ff;
  font-size: 18px;
  font-weight: 600;
}

.custom-steps {
  margin-bottom: 32px;
}

.step-content {
  min-height: 300px;
  margin-bottom: 24px;
}

.step-panel {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 24px;
  border: 1px solid #e8e8e8;
}

.step-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1890ff;
}

.step-title h4 {
  margin: 0 0 0 8px;
  color: #1890ff;
  font-size: 16px;
  font-weight: 600;
}

.step-body {
  background: white;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.search-result {
  margin-top: 16px;
}

.transfer-preview {
  margin-top: 20px;
}

.transfer-summary {
  max-width: 600px;
  margin: 0 auto;
}

.step-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0;
  border-top: 1px solid #f0f0f0;
}

.step-btn {
  min-width: 120px;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  margin: 0 8px;
}

.execute-btn {
  background: linear-gradient(135deg, #52c41a, #389e0d);
  border-color: #52c41a;
  box-shadow: 0 4px 12px rgba(82, 196, 26, 0.3);
}

.execute-btn:hover {
  background: linear-gradient(135deg, #73d13d, #52c41a);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(82, 196, 26, 0.4);
}

/* 響應式調整 */
@media (max-width: 768px) {
  .step-actions {
    flex-direction: column;
    gap: 12px;
  }
  
  .step-btn {
    width: 100%;
    max-width: 200px;
  }
  
  .step-panel {
    padding: 16px;
  }
}

.score-display {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #f6f8fa;
  border-radius: 6px;
  border: 1px solid #e8e8e8;
  font-size: 16px;
}

.score-value {
  font-weight: 600;
  color: #333;
  font-size: 18px;
}

.score-unit {
  color: #666;
  margin-left: 4px;
}

.score-card {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f6f8fa 0%, #e8f4fd 100%);
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.score-icon {
  font-size: 24px;
  margin-right: 12px;
}

.score-icon.gold {
  color: #faad14;
}

.score-icon.green {
  color: #52c41a;
}

.score-info {
  display: flex;
  align-items: baseline;
}

.score-number {
  font-size: 20px;
  font-weight: 700;
  color: #1890ff;
}

.score-text {
  font-size: 14px;
  color: #666;
  margin-left: 4px;
}

/* 新增樣式 */
.available-score-info {
  margin-bottom: 20px;
}

.score-info-card {
  border: 2px solid #e6f7ff;
  background: linear-gradient(135deg, #f6ffed 0%, #e6f7ff 100%);
}

.score-info-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}

.transferor-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.transferor-name {
  font-weight: 600;
  color: #1890ff;
  font-size: 16px;
}

.available-score {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.score-label {
  color: #666;
  font-size: 14px;
}

.score-amount {
  font-size: 24px;
  font-weight: 700;
  color: #1890ff;
}

.score-unit {
  color: #666;
  font-size: 14px;
}

.transfer-error,
.transfer-hint {
  margin-top: 8px;
}

.preview-card {
  border: 2px solid #fff2e8;
  background: #fff7ed;
}

.preview-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
}

.transfer-item {
  flex: 1;
  text-align: center;
}

.transfer-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-bottom: 8px;
  font-weight: 600;
  color: #666;
}

.transfer-detail {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.user-name {
  font-weight: 600;
  color: #333;
}

.score-change {
  font-size: 14px;
  color: #666;
}

.transfer-arrow {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 0 20px;
}

.transfer-amount {
  margin-top: 4px;
}

/* 響應式調整 */
@media (max-width: 768px) {
  .score-info-content {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }
  
  .preview-content {
    flex-direction: column;
    gap: 16px;
  }
  
  .transfer-arrow {
    transform: rotate(90deg);
  }
}
.user-found-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.user-found-info span {
  font-weight: 500;
}
.transferor-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.transferor-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.transferor-name {
  font-weight: 600;
  color: #1890ff;
  font-size: 16px;
  line-height: 1.2;
}

.transferor-account {
  font-size: 12px;
  color: #666;
  font-weight: 400;
}

/* 如果您希望在同一行顯示，可以使用這個版本 */
.transferor-details-inline {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.transferor-name-inline {
  font-weight: 600;
  color: #1890ff;
  font-size: 16px;
}

.transferor-account-inline {
  font-size: 14px;
  color: #666;
  font-weight: 400;
}
</style>